<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/gBXL5f/tc-custom/cover.jpg?1684306110259?1706325227565" alt="This image is the cover for the book Technical Writing for Engineering Professionals"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Technical Writing for Engineering Professionals
      </h1>
      <p class="bookDescription body article font2">
        <p>Technical Writing for Engineering Professionals provides a toolkit for developing technical reports quickly and efficiently. The book offers clear, specific guidelines for developing each of the sections (abstract, conclusions, introduction, and discussion) and designing and using graphics that illustrate your results. Weatherford's approach can be applied in all types of writing, from email and letters to project proposals and final reports. The book also includes tips for using English that will help keep your writing crisp and clear. Anyone in a technical profession, from intern to management, who wants to implement a better, faster, and more consistent approach to writing will benefit from reading this book. Key Features -Understand the process of writing a technical report, from the time you know your conclusions until you present it to your supervisor, client, or professional organization. -Get a quick overview of each chapter in the "short form" summary at the beginning, and use the handy checklist at the end to critique each part of your report as you write. -Learn to read literature efficiently and critically and take notes that will help you write your own reports as well as how to cite material that will lend strength to your work.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Darla-Jean Weatherford
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      PennWell
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?636d2aef